import { APP_NAME, RequestMethod } from '~/shared/constants/commonConstants'
import { ApiService } from '~/shared/services/api'
import { IRequestOptions, IResponseResult } from '~/shared/types/apiTypes'
import {
  IAppConfigResponseRaw,
  IPaymentConfigRaw,
} from '~/shared/types/configTypes'

export class ConfigApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getAppConfig(): Promise<IResponseResult<IAppConfigResponseRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
    }

    return this.api.makeRequest<IAppConfigResponseRaw>(
      `v1/flow/${APP_NAME}/config`,
      options,
    )
  }

  getPaymentConfig({
    cohort,
    uuid,
  }: {
    cohort: string
    uuid: string
  }): Promise<IResponseResult<IPaymentConfigRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { uuid },
    }

    return this.api.makeRequest<IPaymentConfigRaw>(
      `v1/flow/${APP_NAME}/variant/${cohort}/payment-config`,
      options,
    )
  }
}
